import moment from 'moment';
const initialState = {
  quickUpdateExpert: false,
  showSkipExpert: true,
  sendZoomUpdateExpert: false,
  expertinviteEdited: null,
  expertMessage: '',
  quickInviteExpert: true,
  expertSubject: '',
  zoomLocationExpert: 'Conference call +49 000 000 0000 // Zoom ID will be created on confirm',
  gotExpertEvent: false,
  inviteExpert: false,
  quickUpdateClient: false,
  showSkipClient: true,
  sendZoomUpdateClient: false,
  clientinviteEdited: null,
  clientSubject: '',
  clientContacts: '',
  clientTitle: '',
  zoomLocationClient: 'Conference call +49 000 000 0000 // Zoom ID will be created on confirm',
  clientMessage: '',
  inviteClient: false,
  gotClientEvent: false,
  quickInviteClient: true,
  skipInviteExpert: false,
  skipInviteClient: false,
  sendZoomUpdate: false,
  submitFirstMatch: false,
  schedule: {
    availabilities: [],
    timeslots: [],
    drafts: [],
    raw: {
      group: []
    }
  },
  eplModels: null,
  selectedDate: new Date().getTime(),
  numberData: [],
  topicAvail: false,
  submitCreateZoom: false,
  additionalEmailsClient: [],
  additionalEmailsExpert: [],
  // Expert's scheduled time slot from from yesterday to tomorrow, request made by: getTakenExpertSlots

  /* i.e.
    {
      endTime: "2022-01-08T07:00:00.000Z"
      scheduleId: 118588
      startTime: "2022-01-08T06:00:00.000Z"
    }
  */
  takenExpertSlots: [],
  initting: false,
  readOnly: true,
  updated: false,
  currentPath: '',
  lastPath: '',
  // first matching time between expert and client availability in milliseconds
  firstMatch: 0,
  // Teams with label and value, set on FasterScheduling.js getTeams methods
  activeTeams: [],
  gotTeams: false,
  // Default to user's team set on FasterScheduling.js getTeams methods
  selectedTeam: [],
  zoomNum: [],
  quick: false,
  zoomTopic: '',
  callJoinUrl: '',
  // Duration of call in minutes
  duration: 60,
  availabilityStore_imp: {},
  showTimeslots: false,
  disableAddAnotherExpert: true,
  dateDetails: {},
  focus: 'startDate',
  expertTimezone: null,
  clientTimezone: '',
  dayToRender: moment(),
  clientZone: {},
  expertZone: {},
  // time string to indicate where schedule bar is dropped. e.g. 13:00
  timeOnDrop: '',
  // ops current start time to schedule
  // Looks like e.g. { hour: 10, minutes: 0 }
  opsTime: null,
  eplId: 0,
  renderSpinner: false,
  ExpertOffsetSet: false,
  attachExpertProfilePdf: true,
  attachExpertScreeningQuestions: true,
  clientContactOptions: [],
  scheduleRequests: [],
  existingZoomMeeting: [],
  zoomMeetingIdToAttach: 0,
  submiteNewSchedule: false,
  tempSchedule: {},
  templates: [],
  selectedTemplate: {},
  selectedLanguage: 'english',
  // String of employee information concatted
  employeeSubmitted: '',
  expertModels: [],
  expertsAdded: [],
  connectedZoomMeeting: [],
  allZoomNumbers: [],
  templateLanguages: ['English', 'Chinese', 'French', 'German', 'Italian', 'Korean', 'Portuguese', 'Russian', 'Spanish', 'Japanese', 'Polish'],
  expertCountry: '',
  expertTimezoneName: '',
  expertInvited: false,
  clientInvited: false,
  meetingType: 'Zoom',
  languageUpdated: false,
  previouslySend: '',
  expertEventMessage: '',
  timezoneTranslated: false,
  templateId: null,
  previouslySendLanguage: '',
  clientMessageTypeOfNone: `
    <p>Dear Mr. Andrew Lee</p>
    <p>I am pleased to confirm the consultation call scheduled with  Mr. Zoltan Lukac,  Head of Business Development - Food Service - Innovation, Martin Bauer Group,  for Segment: Experts</p>
    <p>In case of any queries, please do not hesitate to contact me via email or via phone.</p>
    <p>Please accept this invitation before the time of consultation.</p>`,
  expertInfo: '',
  userPosition: '',
  userPhoneNumbers: '',
  typeUpdated: false,
  mcKinseyNumbers: [],
  onQuick: false,
  onCustom: false,
  clientDayOffset: 0,
  expertDayOffset: 0,
  mcKinseyTemplates: null,
  mcKinseyMessage: null,
  locationClient: 'Conference call',
  locationExpert: 'Conference call',
  clientTimezoneName: '',
  showExpertCountry: true,
  sendSmsExpertPhoneNumber: false,
  sendSmsToPhoneNumberIds: [],
  expertPhoneNumbers: [],
  expertMessageUpdated: false,
  clientMessageUpdated: false,
  numberOfAdditionalExpertEmail: 0,
  numberOfAdditionalClientEmail: 0,
  numberOfAddedClientEmail: 0,
  anonymizeClients: true,
  anonymizeExpert: false
};
export default initialState;